var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-page-wrapper"},[_c('Aside'),_c('Main',[_c('Navbar'),_c('div',{staticClass:"service-page-inner container"},[_c('p',[_vm._v("service")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }